module.exports = __webpack_public_path__ + "img/boost.be8a1a37.png";